export default __webpack_public_path__ + "static/media/logoNB.50ed2a81.png";